import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { GlobalConstants } from '@globalConstants';
import { IUser } from '@interfaces/IUser';
import { IAppState } from '@myStore/app.state';
import {
  ClearFreeTimeFormRemindLater,
  FreeTimeFormRemindLaterRequest,
  SendFreeTimeGraphRequest,
} from '@myStore/ESDP-changes/ESDP-changes.actions';
import { selectChangesESDPLoading } from '@myStore/ESDP-changes/ESDP-changes.selector';
import {
  selectProfile,
  selectProfileViewLoading,
} from '@myStore/profile-view/profile-view.selector';
import { select, Store } from '@ngrx/store';
import { FormDialogComponent } from '@shared/components/UI/form-dialog/form-dialog.component';
import { isControlsIsValid } from '@shared/utils/formUtils';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-free-time-graph-form',
  templateUrl: './free-time-graph-form.component.html',
  styleUrls: ['./free-time-graph-form.component.sass'],
})
export class FreeTimeGraphFormComponent implements OnInit, OnDestroy {
  sendLoading$ = this._store.select(selectChangesESDPLoading);
  types = GlobalConstants.ESDPTimes;
  student?: IUser;
  timeGraphForm = new UntypedFormGroup({
    time_ranges: new UntypedFormControl([], [Validators.required]),
    student_id: new UntypedFormControl(null),
  });
  public selectedTimes = new Set<number>();
  public isEdit = this.dialogRef.componentInstance.data.isEdit;
  public profileLoading$ = false;
  private destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private _store: Store<IAppState>,
    public dialogRef: MatDialogRef<FormDialogComponent>,
    public _toastr: ToastrService
  ) {}

  ngOnInit(): void {
    const dialogData = this.dialogRef.componentInstance.data;
    this.dialogRef.disableClose = dialogData.disableClose;
    this.student = dialogData.student;

    this._store
      .pipe(select(selectProfileViewLoading), takeUntil(this.destroy$))
      .subscribe(loading => {
        if (this.profileLoading$ && !loading) {
          this.onCancel();
        }

        this.profileLoading$ = loading;
      });

    this._store
      .pipe(select(selectProfile), takeUntil(this.destroy$))
      .subscribe(profile => {
        const times = profile?.free_time_form?.time_ranges.split(',');
        const types: { [key: string]: string } = { ...this.types };

        if (times) {
          times.forEach((time: string) => {
            if (time) {
              const number = Number(types[time.trim()]);

              this.selectedTimes.add(number);
            }
          });
        }
      });
  }

  onSubmit() {
    this.timeGraphForm.patchValue({ time_ranges: [...this.selectedTimes] });
    if (this.student?.id) {
      if (isControlsIsValid(this.timeGraphForm.controls)) {
        if (this.student?.free_time_form) {
          this._store.dispatch(
            new SendFreeTimeGraphRequest(
              {
                time_ranges: [...this.selectedTimes],
                student_id: this.student.free_time_form.id,
              },
              this.student.id
            )
          );
        }
      } else {
        this._toastr.error('Выберите время');
      }
    }
  }

  onCancel() {
    this.selectedTimes.clear();
    this.dialogRef.close();
  }

  toggleSelectionTimes(timeId: string) {
    const id = Number(timeId);
    this.selectedTimes.has(id)
      ? this.selectedTimes.delete(id)
      : this.selectedTimes.add(id);
  }

  isSelectTime(timeId: number) {
    const id = Number(timeId);
    return this.selectedTimes.has(id);
  }

  remindLater() {
    if (this.student?.id) {
      this._store.dispatch(new FreeTimeFormRemindLaterRequest(this.student.id));
    }
  }

  ngOnDestroy(): void {
    this._store.dispatch(new ClearFreeTimeFormRemindLater());
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
